import React from "react";
import { FullDrawContainer } from "./FullDrawContainer";
import { KeyPersonnelProfileView } from "newui/features/Company/KeyPersonnel";

interface KeyPersonnelFullDrawerProps {
	companyId: number;
	isOpen: boolean;
	onClose: () => void;
}

export const KeyPersonnelFullDrawer: React.FC<KeyPersonnelFullDrawerProps> = ({
	isOpen,
	onClose,
	companyId,
}) => {

	return (
		<FullDrawContainer
			isOpen={isOpen}
			onClose={onClose}
			title="View all personnel"
		>
			<KeyPersonnelProfileView companyId={companyId} />
		</FullDrawContainer>
	);
};
